var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0156 9.98438H17.0156L12 5.01562L6.98438 9.98438H9.98438V14.0156H14.0156V9.98438ZM19.3594 7.03125C20.6406 7.125 21.7344 7.65625 22.6406 8.625C23.5469 9.5625 24 10.6875 24 12C24 13.375 23.5 14.5625 22.5 15.5625C21.5312 16.5312 20.3594 17.0156 18.9844 17.0156H6C4.34375 17.0156 2.92188 16.4375 1.73438 15.2812C0.578125 14.0938 0 12.6719 0 11.0156C0 9.54688 0.515625 8.23438 1.54688 7.07812C2.60938 5.89062 3.875 5.21875 5.34375 5.0625C6 3.84375 6.92188 2.85938 8.10938 2.10938C9.29688 1.35938 10.5938 0.984375 12 0.984375C13.6875 0.984375 15.25 1.57813 16.6875 2.76562C18.1562 3.95312 19.0469 5.375 19.3594 7.03125Z",
    fill: "#C6C6C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.6b2b310c.svg";
export { ForwardRef as ReactComponent };